import { selectOutcomeStatusLine } from "./outcome-context";

import {
  OutcomeType,
  PageOutcomeType,
  PageType,
  SectionOutcomeType,
} from "components/server-types";
import { t } from "i18n/i18n";
import { RootState } from "store/index";
import { outcomeSelectors, pageOutcomeSelectors, sectionOutcomeSelectors } from "store/selectors";

export const selectPageStatusLine = (state: RootState, page: PageType) => {
  const outcomes = outcomeSelectors.selectAll(state);
  const sectionOutcomes = sectionOutcomeSelectors.selectAll(state);
  const pageOutcomes = pageOutcomeSelectors.selectAll(state);
  return getPageStatusLine(page, pageOutcomes, sectionOutcomes, outcomes);
};

export const getPageStatusLine = (
  page: PageType,
  pageOutcomes: PageOutcomeType[],
  sectionOutcomes: SectionOutcomeType[],
  outcomes: OutcomeType[],
) => {
  const thisPageOutcomes = pageOutcomes.filter((po) => po.page_id === page.id);
  const thisSectionOutcomes = sectionOutcomes.filter((co) =>
    thisPageOutcomes.some((po) => po.section_outcome_id === co.id),
  );
  const thisOutcomes = outcomes.filter((o) =>
    thisSectionOutcomes.some((po) => po.outcome_id === o.id),
  );
  const outcomeStatusLine = selectOutcomeStatusLine(thisOutcomes);
  const status = page.released_at ? t("ai.page_status.released") : t("ai.page_status.unreleased");
  return `Page "${page.title}" (id "${page.id}") (${status}) using ${outcomeStatusLine}`;
};
